export default __webpack_public_path__ + "7af63abff536941b19d2907584e7ae7d.svg";